import { GlobalHeader, ProfileProps } from '@design-system/global-header';
import { Events } from '@phx-husky/auth-service';
import { useUserSession } from '@phx-husky/use-user-session';
import { navigate } from 'gatsby';
import React, { useContext, useEffect, useState } from 'react';

import { StoreContext } from '~/context/shopify';
import { useAutocomplete } from '~/hooks/useAutocomplete';
import { headerMapper } from '~/mappers/header';
import { Header } from '~/mappers/header/models';
import { gtmService } from '~/services/gtm';

import { getUserName } from './utils';

const HeaderWrapWithProfile = (header: Header) => {
  const [userName, setUserName] = useState(getUserName());
  const { autocompleteState, getInputProps } = useAutocomplete();
  const { checkout } = useContext(StoreContext);

  const mapped = headerMapper({ ...header, checkout });

  const { isSignedIn, signOut } = useUserSession();

  const handleUserNameChange = (event) => {
    const { newUserName } = event.detail;

    setUserName(newUserName);
  };

  useEffect(() => {
    window.addEventListener(Events.onUserNameUpdate, handleUserNameChange);

    return () => {
      window.removeEventListener(Events.onUserNameUpdate, handleUserNameChange);
    };
  }, []);

  return (
    <GlobalHeader
      {...{
        ...mapped,
        profile: {
          ...mapped.profile,
          isSignedIn,
          handleSignOut: () => signOut(),
          handleLogIn: () => navigate(mapped.profile!.logIn.link),
          handleRegister: () => navigate(mapped.profile!.register.link),
          userName,
        } as ProfileProps,
        search: mapped.search
          ? {
              ...mapped.search,
              autocomplete: { autocompleteState, getInputProps },
            }
          : undefined,
        onClickNavItem: (value) => gtmService.emitHeaderMenuClick(value),
      }}
    />
  );
};

export default HeaderWrapWithProfile;
